// import ReactDOMServer from "react-dom/server";
// import InvoiceTemplate from "./InvoiceTemplate";

// export const printInvoice = (invoice) => {
//   const printWindow = window.open("", "_blank");

//   const html = ReactDOMServer.renderToString(
//     <InvoiceTemplate invoice={invoice} />
//   );

//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>Invoice ${invoice.id}</title>
//         <script src="https://cdn.tailwindcss.com"></script>
//         <style>
//           @media print {
//             body { margin: 0; }
//           }
//         </style>
//       </head>
//       <body onload="window.print(); window.close();">
//         ${html}
//       </body>
//     </html>
//   `);

//   printWindow.document.close();
// };
import ReactDOMServer from "react-dom/server";
import InvoiceTemplate from "./InvoiceTemplate";

export const printInvoice = (invoice, template = "custom") => {
  const printWindow = window.open("", "_blank", "width=900,height=650");

  const html = ReactDOMServer.renderToString(
    <InvoiceTemplate invoice={invoice} template={template} />
  );

  printWindow.document.open();
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Invoice ${invoice.invoiceNo || invoice.id}</title>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <!-- Tailwind -->
        <script src="https://cdn.tailwindcss.com"></script>

        <style>
          body {
            margin: 0;
            padding: 0;
            background: white;
          }

          @page {
            size: A4;
            margin: 10mm;
          }

          @media print {
            body {
              margin: 0;
            }

            .no-print {
              display: none !important;
            }

            .page-break {
              page-break-before: always;
            }
          }
        </style>
      </head>

      <body>
        <div id="print-root">
          ${html}
        </div>

        <script>
          window.onload = function () {
            window.focus();
            window.print();
            window.close();
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};
